export default {
  paddingSmall: '12px 16px 12px',
  paddingMedium: '19px 24px 20px',
  paddingLarge: '23px 32px 24px',
  paddingHuge: '27px 40px 28px',
  titleFontSizeSmall: '16px',
  titleFontSizeMedium: '18px',
  titleFontSizeLarge: '18px',
  titleFontSizeHuge: '18px',
  closeIconSize: '18px',
  closeSize: '22px'
};